import { load, navigateTo, Obj, urlForDataItem } from 'scrivito'

import type {
  NavigateTarget,
  NavigationConnector,
} from '../../core/engine/contracts'
import { resolvePageContext } from '../../core/engine/pipeline/page-context'
import { writeUrlParams, type UrlParamsPatch } from '@/hooks/useUrlParams'

export const scrivitoNavigationConnector: NavigationConnector = {
  async urlFor(item: unknown): Promise<string | undefined> {
    // warning: Scrivito does not export DataItem publicly; the boundary cast uses
    // the urlForDataItem parameter type, which is the same established pattern as
    // tools/shared/resolveEntityReference.ts (forced by Scrivito's type exports).
    const scrivitoItem = item as Parameters<typeof urlForDataItem>[0]
    return (
      (await load(() => urlForDataItem(scrivitoItem)).catch(() => undefined)) ??
      undefined
    )
  },

  navigate(target: NavigateTarget): void {
    if ('url' in target) {
      if (target.newTab) {
        window.open(target.url, '_blank', 'noopener')
        return
      }
      navigateTo(target.url)
      return
    }
    const { permalink, params, query } = target
    if (params !== undefined || query !== undefined) {
      navigateTo(() => Obj.getByPermalink(permalink), { params, query })
    } else {
      navigateTo(() => Obj.getByPermalink(permalink))
    }
  },

  resolvePageContext() {
    return resolvePageContext()
  },

  writeUrlParams(patch, replace) {
    // Record<string, string | null | undefined> ⊆ UrlParamsPatch
    // (UrlParamValue allows arrays too; the host-neutral interface narrows to
    // string-only values). The cast is safe — every value type in our interface
    // is a valid UrlParamValue.
    writeUrlParams(patch as UrlParamsPatch, replace)
  },
}
